import { UserCredential } from 'firebase/auth';

import AuthApi, { CreateUserCredentials } from '../api/authApi';
import UserProfileApi from '../api/userProfileApi';
import { getDefaultUserImageUrl } from '../utils/functions';

export default class AuthService {
  /**
   * Creates a new user account and a matching user profile.
   * @param credentials
   */
  public static async createAccount(credentials: CreateUserCredentials): Promise<UserCredential> {
    const { email, password, researchConsent } = credentials;
    return AuthApi.addUser(email, password).then(credential => {
      UserProfileApi.addUserProfile({
        uuid: credential.user.uid,
        title: '',
        description: '',
        imageUrl: getDefaultUserImageUrl(),
        imageStoragePath: '',
        instagram: '',
        facebook: '',
        linkedIn: '',
        twitter: '',
        role: 'MEMBER',
        researchConsent,
      });
      return credential;
    });
  }
}
